import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import ShellLayout from '@/layouts/Shell.Layout';
import { useAppSelector } from '@/store/store.hooks';
import { selectSessionStatus } from '@/store/auth/auth.selectors';
import SessionSplash from '@/router/Session.Splash';

const RequireSession: React.FC = () => {
    const status = useAppSelector(selectSessionStatus);
    const location = useLocation();

    if (status === 'unknown') return <SessionSplash />;

    if (status === 'anonymous') {
        const next = `${location.pathname}${location.search}`;
        const target = next && next !== '/' ? `/auth/login?next=${encodeURIComponent(next)}` : '/auth/login';
        return <Navigate to={target} replace />;
    }

    return <ShellLayout />;
};

export default RequireSession;
